import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState } from 'react'
import moment from 'moment'

import ContentFrame from 'components/Frame/ContentFrame'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function TerraBackfill({ userId }) {
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')

    const BackfillTerraData = async () => {

        if (!startDate || !endDate) {
            alert('Please select both start and end dates')
            return
        }

        // Convert local dates to UTC with proper time formatting using moment
        const startDateTime = moment(startDate + ' 00:00:00').utc()
        const endDateTime = moment(endDate + ' 23:59:59').utc()
        
        const jsonBody = {
            userId: userId,
            backfillStartDate: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
            backfillEndDate: endDateTime.format('YYYY-MM-DD HH:mm:ss')
        }

        // console.log(jsonBody)
       
        const result = await WhichWeightAPI("CORE", "POST", "/terra_backfill_post", jsonBody);

        // console.log(result)

        if (result.status === 'failure') {
            alert("Backfill request failed!")
            return
        }

       alert("Backfill request received")

   }

    return (
        <ContentFrame>
            <div className="w-full flex p-4 items-center">
                <div className="flex-grow text-lg pl-2">Backfill Terra Data</div>
                
                <div className="flex items-center gap-4">
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                    
                    <span className="text-gray-500 font-medium">-</span>
                    
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />

                    <div className="w-32">
                        <BrandColorButton 
                            text="Backfill"
                            action={() => BackfillTerraData()}
                        />
                    </div>
                </div>
            </div>
        </ContentFrame>
    )
}